/**
 * @file 学位/毕业论文申请API
 * @author dws
 */

import request from "@/utils/request";

// 查询学位申请学生可申请列表
export async function getAcademicDegreeQuery() {
  return request.get(`/paperApplyV2/academicDegreeQuery`);
}

// 查询学生学位申请记录
export async function getStudentAcademicDegreeQuery() {
  return request.get(`/paperApplyV2/studentAcademicDegreeQuery`);
}

// 查询论文申请学生可申请列表
export async function getPaperQuery() {
  return request.get(`/paperApplyV2/paperQuery`);
}

// 查询学生论文申请记录
export async function getStudentPaperQuery() {
  return request.get(`/paperApplyV2/studentPaperQuery`);
}

// 获取申请材料
export async function getOther(id) {
  return request.get(`/paperApplyV2/getOther/${id}`);
}


// 申请论文
export async function paperApply(id) {
  return request.post(`/paperApplyV2/paperApply/${id}`);
}

// 申请学位
export async function academicDegreeApply(data) {
  return request.post(`/paperApplyV2/academicDegreeApply/${data.id}`, data);
}

// 论文管理or学位论文管理
export async function getStudentPaperMessageList(data) {
  return request.post(`/paperApplyV2/getListPaperMessage`, data);
}

// 发送内容
export async function confirmSendingPaperApplyMessage(data) {
  return request.post(`/paperApplyV2/initiateGuidanceSend`, data);
}

// 上传论文
export async function uploadPaper(data) {
  return request.post(`/paperApplyV2/uploadPaper`, data);
}

// 获取当前阶段
export async function getStudentPaperApplyById(id) {
  return request.get(`/paperApplyV2/getOne/${id}`);
}